module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag23_1147AT.0bebd78a.jpg";